<script setup lang="ts">
import { defineEmits, defineProps, ref } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  exampleArchive: any | null | undefined;
  selectedStepId?: number;
};

type Emits = {
  (event: "selectExampleStep", phaseId: number, stepId: number): void;
};

const props = defineProps<Props>();
const emits = defineEmits<Emits>();

const isExamplePhaseDropdown = ref(false);
const selectedExamplePhase = ref();
const { t } = useTranslate();

const toggleExampleDropdown = (examplePhase: any) => {
  if (selectedExamplePhase.value === examplePhase) {
    isExamplePhaseDropdown.value = !isExamplePhaseDropdown.value;

    if (!isExamplePhaseDropdown.value) {
      selectedExamplePhase.value = null;
    }
  } else {
    selectedExamplePhase.value = examplePhase;
    isExamplePhaseDropdown.value = true;
  }
};
</script>

<template>
  <div class="w-[220px] h-[calc(100vh-37px)] overflow-y-scroll">
    <!-- Phases -->
    <div
      v-for="phase in props.exampleArchive"
      :key="phase.id"
      class="w-full rounded-[4px] m-[2px] mt-[1px] ml-[1px] py-4 px-3 bg-[#E5E4E2]"
    >
      <div>
        <h4
          class="text-base leading-[26px] tracking-[0.01rem] uppercase font-medium text-[#51687A]"
        >
          {{ phase?.name }}
        </h4>
      </div>
      <!-- Menu items -->
      <div class="w-full flex flex-col items-start mt-2">
        <!-- Review -->
        <div @click="toggleExampleDropdown(phase.id)">
          <div
            class="w-full flex items-start gap-1 cursor-pointer p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300"
          >
            <img
              v-if="selectedExamplePhase === phase.id"
              src="@/assets/caret_up.svg"
              alt="Caret down"
            />
            <img v-else src="@/assets/caret_down.svg" alt="caret up" />
            <h5
              class="text-[#393840] font-medium text-sm tracking-[0.01rem] pr-1"
            >
              {{ t("global.example_images") }}
            </h5>
          </div>
        </div>
        <ul v-if="selectedExamplePhase === phase.id" class="mt-[3px] pl-4">
          <li
            class="w-full flex flex-col gap-2 p-[2px] pl-[6px] border-l-[2px] border-[#D3D1CD]"
            v-for="step in phase.steps"
            :key="step.id"
            :class="selectedStepId === step.id ? 'border-[#70899c]' : ''"
          >
            <div
              @click="emits('selectExampleStep', phase.id, step.id)"
              class="w-full relative text-sm p-[6px] rounded-primary-radius bg-transparent text-primary-text-color font-medium tracking-[0.01rem] cursor-pointer hover:bg-[#D3D1CD] duration-300"
              :class="
                selectedStepId === step.id ? 'bg-white' : 'bg-transparent'
              "
            >
              {{ step.name }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
